import { createContext, useCallback, useContext, useMemo, useState } from "react";
import { SORT_OPTIONS } from "../constants/sortOptions";
import PropTypes from "prop-types";
import { useSortParam } from "../hooks/useSortParam";

const SortContext = createContext(null);

export const SortProvider = ({
	defaultSort = SORT_OPTIONS.RECOMMENDATION.id,
	options = SORT_OPTIONS,
	children,
}) => {
	const [isOpen, setIsOpen] = useState(false);

	const { sortBy, setSortBy } = useSortParam({ defaultValue: defaultSort });

	const openDrawer = useCallback(() => setIsOpen(true), []);
	const closeDrawer = useCallback(() => setIsOpen(false), []);

	const value = useMemo(
		() => ({
			isOpen,
			openDrawer,
			closeDrawer,
			sortBy,
			setSortBy,
			options,
		}),
		[isOpen, openDrawer, closeDrawer, sortBy, setSortBy]
	);

	return <SortContext.Provider value={value}>{children}</SortContext.Provider>;
};

SortProvider.propTypes = {
	defaultSort: PropTypes.string,
	options: PropTypes.object,
	children: PropTypes.node,
};

export const useSortContext = () => {
	const ctx = useContext(SortContext);

	if (!ctx) {
		throw new Error("useSortContext must be used within <SortProvider>");
	}

	return ctx;
};
